export const BRUSHES_VEHICLE_OTHER_LABEL = 'Other'

export interface BrushesVehicle {
    id?: number
    label: string
}
